export default "__VITE_ASSET__CihWl9qG__"